import { render, staticRenderFns } from "./Need.vue?vue&type=template&id=379817cf&scoped=true&"
import script from "./Need.vue?vue&type=script&setup=true&lang=js&"
export * from "./Need.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379817cf",
  null
  
)

export default component.exports